import { render, staticRenderFns } from "./modalComponent.vue?vue&type=template&id=af16e118&scoped=true&"
import script from "./modalComponent.vue?vue&type=script&lang=js&"
export * from "./modalComponent.vue?vue&type=script&lang=js&"
import style0 from "./modalComponent.vue?vue&type=style&index=0&id=af16e118&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af16e118",
  null
  
)

export default component.exports